import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import userTheme from "./muiTheme";

/**
 * Wraps the user-facing pages in the site theme. Admin and creator layouts stay
 * outside it, so they keep the default MUI palette.
 */
export default function UserThemeProvider({ children }) {
    return <ThemeProvider theme={userTheme}>{children}</ThemeProvider>;
}
